export const T = {
  en_GB: {
    addLiability: "Add Liability",
    noItemsYet: "No items added yet. Click the button above to add.",
    fieldLabels: {
      mortgage: "Mortgage",
      car_loan: "Car Loan",
      other_secured: "Other Secured Debt",
      personal_loans: "Personal Loans",
      credit_cards: "Credit Card Debt",
      student_loans: "Student Loans",
      guarantees: "Guarantees Given",
    },
  },
  nb_NO: {
    addLiability: "Legg til gjeld",
    noItemsYet: "Ingen poster lagt til ennå. Klikk på knappen over for å legge til.",
    fieldLabels: {
      mortgage: "Boliglån",
      car_loan: "Billån",
      other_secured: "Annen sikret gjeld",
      personal_loans: "Forbrukslån",
      credit_cards: "Kredittkortgjeld",
      student_loans: "Studielån",
      guarantees: "Gitte garantier",
    },
  },
} as const;
